import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'cv-file',
});

export async function getCvFile(uuid = null) {
    return backendEndpoint.get('/', {
        params: { uuid },
    });
}
